import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCookie } from '../utils/cookies';

const ProtectedRoute = ({ children }) => {
  const token = getCookie('token');
  return token ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
